<div class="edit-number">
  @if (data) {
    <h4 class="phone-emoji">📱</h4>
  }
  <h1>{{'edit-mobile-number.Edit' | translate }}</h1>
  <h2>{{'edit-mobile-number.Registered' | translate }}</h2>
  <ion-item [ngClass]="isNumberInvalid ? 'invalid-field': ''" class="country-select"
    (focusin)="flagsDropdownToggle(true)">
    <input type="tel" maxlength="12" placeholder="Mobile" (keypress)="numericOnly($event)"
      (hasError)="phoneNumberHasError($event)"  class="login-phone-number"
      (countryChange)="flagsDropdownToggle(false); getAllSelected($event);" #phoneNumber />
    </ion-item>
    <p class="code-hint">{{'edit-mobile-number.verification' | translate }}</p>
    @if (isNumberInvalid) {
      <div class="errorContainer">
        <ion-icon name="warning" class="icon"></ion-icon>
        @if (phoneInValid) {
          <span class="text">{{'edit-mobile-number.Please' | translate }}</span>
        }
        @if (!phoneInValid) {
          <span class="text">{{'edit-mobile-number.mobile' | translate }}</span>
        }
      </div>
    }
    <ion-button expand="block" color="secondary" [disabled]="isNumberInvalid" (click)="updateMobileNumber()"
    class="capsule-btn">{{'edit-mobile-number.Update' | translate }}</ion-button>

    <h3 (click)="back()">← {{'edit-mobile-number.Back' | translate }}</h3>
  </div>